import api from './api';

/**
 * Serviço de autenticação — Modelo A (empresa + filial).
 * Endpoints: /api/auth/*
 */

export async function login({ login, senha, empresaId, filialId }) {
  const { data } = await api.post('/api/auth/login', {
    login,
    senha,
    empresaId,
    filialId,
  });
  return data;
}

/** A própria pessoa troca a senha (inclusive a provisória do 1º acesso). Devolve novo csrfToken. */
export async function trocarSenha({ senhaAtual, novaSenha }) {
  const { data } = await api.post('/api/auth/trocar-senha', { senhaAtual, novaSenha });
  return data;
}

/** F2.2: confirma a senha da própria sessão para desbloquear a tela coberta por inatividade (sem sair). */
export async function confirmarSenha(senha) {
  const { data } = await api.post('/api/auth/confirmar-senha', { senha });
  return data;
}

/** Apaga o cookie httpOnly da sessão no back (o front não consegue apagá-lo). */
export async function logout() {
  const { data } = await api.post('/api/auth/logout');
  return data;
}

export async function me() {
  const { data } = await api.get('/api/auth/me');
  return data;
}

export async function selecionarContexto({ empresaId, filialId }) {
  const { data } = await api.post('/api/auth/selecionar-contexto', {
    empresaId,
    filialId,
  });
  return data;
}

export async function listarEmpresas() {
  const { data } = await api.get('/api/auth/empresas');
  return data;
}

export async function listarFiliais(empresaId) {
  const { data } = await api.get(`/api/auth/empresas/${empresaId}/filiais`);
  return data;
}
